module.exports = "https://static.energy5.com/_next/static/images/unlimitedPossibilitiesImage-c3b191f94a69de85166c8abbb6ba534f.jpg";